import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import uuidv4 from 'uuid/v4';

import gameTypeColor from './../../../utils/gameTypeColor';

class YearEventObject extends Component {
  state = {
    id: uuidv4(),
    hover: false
  }

  handleToggleHover = () => {
    const { hover } = this.state;

    return this.setState({ hover: !hover });
  }

  render() {
    const { gameType, gameCount, isPassed } = this.props;
    const { id, hover } = this.state;

    return (
      <li
        data-tip
        data-for={id}
        style={{
          color: '#000',
          backgroundColor: gameTypeColor(isPassed && !hover ? undefined : gameType)
        }}
        onMouseEnter={this.handleToggleHover}
        onMouseLeave={this.handleToggleHover}
      >
        {gameCount}
        <ReactTooltip place="right" type="light" effect="float" id={id}>
          {gameType}
        </ReactTooltip>
      </li>
    );
  }
}

YearEventObject.propTypes = {
  gameType: PropTypes.string.isRequired,
  gameCount: PropTypes.number.isRequired,
  isPassed: PropTypes.bool.isRequired
};

export default YearEventObject;



// WEBPACK FOOTER //
// ./src/components/YearEvents/YearEventObject/YearEventObject.js